import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CounselorNav } from '../counselor-nav/counselor-nav';
import { RoleService, Role, SchoolUser } from '../../../../services/role.service';
import { take } from 'rxjs';
import { AddUserDialog } from './add-user-dialog/add-user-dialog';
import { MatDialog } from '@angular/material/dialog';
import { HasPermissionDirective } from '../../../../security/has-permission.directive';
import { USER_PERMISSIONS } from '../../../../constants/permissions';

@Component({
  selector: 'app-user-management',
  standalone: true,
  imports: [CounselorNav, CommonModule, FormsModule, HasPermissionDirective],
  templateUrl: './user-management.html',
  styleUrl: './user-management.css',
})
export class UserManagement implements OnInit {
  private roleService = inject(RoleService);
  private cdr = inject(ChangeDetectorRef);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  permissions = USER_PERMISSIONS;

  users: SchoolUser[] = [];
  roles: Role[] = [];
  loading = true;
  searchTerm = '';
  roleFilter = '';

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;

    this.roleService
      .getRoles()
      .pipe(take(1))
      .subscribe({
        next: (roles) => {
          this.roles = roles;
        },
        error: (err) => console.error('Failed to load roles:', err),
      });

    this.roleService
      .getSchoolUsers()
      .pipe(take(1))
      .subscribe({
        next: (users) => {
          this.users = users;
          this.loading = false;
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Failed to load users:', err);
          this.loading = false;
        },
      });
  }

  get filteredUsers(): SchoolUser[] {
    let result = this.users;

    if (this.searchTerm.trim()) {
      const term = this.searchTerm.toLowerCase();
      result = result.filter(
        (u) =>
          u.first_name?.toLowerCase().includes(term) ||
          u.last_name?.toLowerCase().includes(term) ||
          u.email?.toLowerCase().includes(term) ||
          (u.preferredName && u.preferredName.toLowerCase().includes(term)),
      );
    }

    if (this.roleFilter) {
      const roleId = Number(this.roleFilter);
      result = result.filter((u) => u.Roles.some((r) => r.id === roleId));
    }

    return result;
  }

  getDisplayName(user: SchoolUser): string {
    const first = user.preferredName || user.first_name || '';
    return `${first} ${user.last_name || ''}`.trim();
  }

  getUserRoleNames(user: SchoolUser): string {
    if (!user.Roles || user.Roles.length === 0) return 'No roles assigned';
    return user.Roles.map((r) => r.name).join(', ');
  }

  manageUser(userId: number): void {
    this.router.navigate(['/counselors/users', userId]);
  }

  manageRoles(): void {
    this.router.navigate(['/counselors/roles']);
  }

  addUser() {
    this.dialog
      .open(AddUserDialog, {
        data: {},
        width: '720px',
        maxWidth: '96vw',
      })
      .afterClosed()
      .subscribe(() => {
        this.loadData();
      });
    console.log('add user');
  }
}
